module.exports = __webpack_public_path__ + "static/media/Logo Black.741b0671.png";